export default __webpack_public_path__ + "static/media/csv.26bbeeb5.jpg";